import type { I18nKey } from './ja'

export const en: Record<I18nKey, string> = {
  'app.name': 'Browser Photo Editor',
  'app.untitled': 'Untitled',
  'menu.file': 'File',
  'menu.file.new': 'New...',
  'menu.file.open': 'Open...',
  'menu.file.save': 'Save Project (ZIP)...',
  'menu.file.export': 'Export Image...',
  'menu.file.close': 'Close',
  'menu.edit': 'Edit',
  'menu.edit.undo': 'Undo',
  'menu.edit.redo': 'Redo',
  'menu.layer': 'Layer',
  'menu.layer.new': 'New Layer',
  'menu.layer.delete': 'Delete Layer',
  'menu.layer.duplicate': 'Duplicate Layer',
  'menu.view': 'View',
  'menu.view.zoomIn': 'Zoom In',
  'menu.view.zoomOut': 'Zoom Out',
  'menu.view.actual': '100%',
  'menu.view.fit': 'Fit on Screen',
  'menu.view.theme': 'Toggle Theme',
  'menu.view.language': '日本語',
  'menu.help': 'Help',
  'menu.help.about': 'About',
  'menu.help.shortcuts': 'Keyboard Shortcuts',
  'tool.move': 'Move Tool',
  'tool.hand': 'Hand Tool',
  'tool.zoom': 'Zoom Tool',
  'tool.marquee': 'Rectangular Marquee Tool',
  'tool.lasso': 'Lasso Tool',
  'tool.wand': 'Magic Wand Tool',
  'menu.image': 'Image',
  'menu.image.size': 'Image Size...',
  'menu.image.canvasSize': 'Canvas Size...',
  'menu.image.rotate90': '90° Clockwise',
  'menu.image.rotate270': '90° Counter Clockwise',
  'menu.image.rotate180': '180°',
  'menu.image.flipH': 'Flip Canvas Horizontal',
  'menu.image.flipV': 'Flip Canvas Vertical',
  'menu.layer.flipH': 'Flip Layer Horizontal',
  'menu.layer.flipV': 'Flip Layer Vertical',
  'menu.layer.rotate90': 'Rotate Layer 90° CW',
  'menu.layer.rotate270': 'Rotate Layer 90° CCW',
  'menu.layer.rotate180': 'Rotate Layer 180°',
  'menu.edit.freeTransform': 'Free Transform',
  'history.crop': 'Crop',
  'history.canvasSize': 'Canvas Size',
  'history.imageSize': 'Image Size',
  'history.rotateCanvas': 'Rotate Canvas',
  'history.flipCanvas': 'Flip Canvas',
  'history.transformLayer': 'Transform Layer',
  'history.freeTransform': 'Free Transform',
  'dialog.canvas.title': 'Canvas Size',
  'dialog.canvas.anchor': 'Anchor',
  'dialog.canvas.current': 'Current size',
  'dialog.image.title': 'Image Size',
  'dialog.image.keepRatio': 'Constrain proportions',
  'dialog.image.method': 'Resample',
  'dialog.image.nearest': 'Nearest Neighbor',
  'dialog.image.bilinear': 'Bilinear',
  'dialog.image.bicubic': 'Bicubic',
  'transform.commit': 'Commit (Enter)',
  'transform.cancel': 'Cancel (Esc)',
  'transform.scale': 'Scale',
  'transform.angle': 'Angle',
  'crop.commit': 'Crop (Enter)',
  'crop.cancel': 'Cancel (Esc)',
  'shortcut.freeTransform': 'Free transform',
  'shortcut.imageSize': 'Image size',
  'shortcut.canvasSize': 'Canvas size',
  'menu.file.exportPsd': 'Export as PSD...',
  'menu.edit.cut': 'Cut',
  'menu.edit.copy': 'Copy',
  'menu.edit.paste': 'Paste',
  'shortcut.copy': 'Copy',
  'shortcut.cut': 'Cut',
  'shortcut.paste': 'Paste (new layer)',
  'history.paste': 'Paste',
  'layer.pasted': 'Pasted Layer',
  'toast.copied': 'Copied',
  'toast.copiedInternal': 'Copied within the app (system clipboard unavailable)',
  'toast.psdWarnings': 'PSD conversion dropped {n} item(s) ({kinds})',
  'adj.levels': 'Levels',
  'adj.curves': 'Curves',
  'adj.brightness-contrast': 'Brightness/Contrast',
  'adj.exposure': 'Exposure',
  'adj.hue-saturation': 'Hue/Saturation',
  'adj.color-balance': 'Color Balance',
  'adj.black-white': 'Black & White',
  'adj.photo-filter': 'Photo Filter',
  'adj.channel-mixer': 'Channel Mixer',
  'adj.invert': 'Invert',
  'adj.posterize': 'Posterize',
  'adj.threshold': 'Threshold',
  'adj.gradient-map': 'Gradient Map',
  'adj.vibrance': 'Vibrance',
  'menu.layer.newAdjustment': 'New Adjustment Layer',
  'menu.layer.newFillSolid': 'New Fill Layer (Solid Color)',
  'menu.layer.newFillGradient': 'New Fill Layer (Gradient)',
  'history.addAdjustment': 'Add Adjustment Layer',
  'history.adjust': 'Adjustment',
  'history.addFill': 'Add Fill Layer',
  'history.fillProps': 'Fill Settings',
  'adj.reset': 'Reset',
  'adj.channel': 'Channel',
  'adj.inputLevels': 'Input Levels',
  'adj.outputLevels': 'Output Levels',
  'adj.gamma': 'Gamma',
  'adj.brightness': 'Brightness',
  'adj.contrast': 'Contrast',
  'adj.offset': 'Offset',
  'adj.hue': 'Hue',
  'adj.saturation': 'Saturation',
  'adj.lightness': 'Lightness',
  'adj.colorize': 'Colorize',
  'adj.shadows': 'Shadows',
  'adj.midtones': 'Midtones',
  'adj.highlights': 'Highlights',
  'adj.preserveLum': 'Preserve Luminosity',
  'adj.reds': 'Reds',
  'adj.yellows': 'Yellows',
  'adj.greens': 'Greens',
  'adj.cyans': 'Cyans',
  'adj.blues': 'Blues',
  'adj.magentas': 'Magentas',
  'adj.tint': 'Tint',
  'adj.filterColor': 'Filter color',
  'adj.density': 'Density',
  'adj.outputChannel': 'Output channel',
  'adj.constant': 'Constant',
  'adj.monochrome': 'Monochrome',
  'adj.levelsCount': 'Levels',
  'adj.thresholdLevel': 'Threshold level',
  'adj.reverse': 'Reverse',
  'fill.color': 'Color',
  'fill.style': 'Style',
  'fill.angle': 'Angle',
  'fill.scale': 'Scale',
  'text.font': 'Font',
  'text.size': 'Size',
  'text.bold': 'Bold',
  'text.italic': 'Italic',
  'text.color': 'Color',
  'text.lineHeight': 'Leading',
  'text.letterSpacing': 'Tracking',
  'text.align': 'Align',
  'text.vertical': 'Vertical',
  'text.fontMissing': 'not installed',
  'text.loadFontFile': 'Load a font file (.ttf / .otf / .woff). Not saved',
  'text.fontFileLoaded': 'Loaded {name} (this session only)',
  'text.loadLocalFonts': 'Load local fonts',
  'text.placeholder': 'Type text',
  'text.commit': 'Commit (Esc / Cmd+Enter)',
  'text.rasterize': 'Rasterize Type',
  'text.boxWidth': 'Paragraph width',
  'history.addText': 'Add Text',
  'history.editText': 'Edit Text',
  'history.rasterizeText': 'Rasterize Type',
  'menu.layer.rasterizeText': 'Rasterize Type',
  'fx.dropShadow': 'Drop Shadow',
  'fx.innerShadow': 'Inner Shadow',
  'fx.outerGlow': 'Outer Glow',
  'fx.innerGlow': 'Inner Glow',
  'fx.bevel': 'Bevel & Emboss',
  'fx.satin': 'Satin',
  'fx.colorOverlay': 'Color Overlay',
  'fx.gradientOverlay': 'Gradient Overlay',
  'fx.stroke': 'Stroke',
  'dialog.style.title': 'Layer Style',
  'dialog.style.blend': 'Blend Mode',
  'dialog.style.opacity': 'Opacity',
  'dialog.style.angle': 'Angle',
  'dialog.style.distance': 'Distance',
  'dialog.style.spread': 'Spread',
  'dialog.style.choke': 'Choke',
  'dialog.style.size': 'Size',
  'dialog.style.color': 'Color',
  'dialog.style.position': 'Position',
  'dialog.style.outside': 'Outside',
  'dialog.style.inside': 'Inside',
  'dialog.style.center': 'Center',
  'dialog.style.depth': 'Depth',
  'dialog.style.soften': 'Soften',
  'dialog.style.altitude': 'Altitude',
  'dialog.style.highlight': 'Highlight',
  'dialog.style.shadow': 'Shadow',
  'dialog.style.invert': 'Invert',
  'dialog.style.source': 'Source',
  'dialog.style.edge': 'Edge',
  'dialog.style.centerSource': 'Center',
  'dialog.style.styleKind': 'Style',
  'dialog.style.inner': 'Inner Bevel',
  'dialog.style.outer': 'Outer Bevel',
  'dialog.style.emboss': 'Emboss',
  'dialog.style.clear': 'Clear All',
  'menu.layer.style': 'Layer Style...',
  'history.layerStyle': 'Layer Style',
  'layer.fx': 'fx',
  'shape.rect': 'Rectangle',
  'shape.ellipse': 'Ellipse',
  'shape.polygon': 'Polygon',
  'shape.line': 'Line',
  'shape.radius': 'Radius',
  'shape.sides': 'Sides',
  'shape.star': 'Star',
  'shape.fill': 'Fill',
  'shape.stroke': 'Stroke',
  'shape.strokeWidth': 'Stroke width',
  'shape.strokeAlign': 'Stroke align',
  'shape.rasterize': 'Rasterize Shape',
  'menu.select.fromLayer': 'Select Layer Transparency',
  'history.addShape': 'Add Shape',
  'history.editShape': 'Edit Shape',
  'history.rasterizeShape': 'Rasterize Shape',
  'menu.layer.rasterizeShape': 'Rasterize Shape',
  'filter.gaussianBlur': 'Gaussian Blur...',
  'filter.boxBlur': 'Box Blur...',
  'filter.motionBlur': 'Motion Blur...',
  'filter.surfaceBlur': 'Surface Blur...',
  'filter.sharpen': 'Sharpen...',
  'filter.unsharpMask': 'Unsharp Mask...',
  'filter.highPass': 'High Pass...',
  'filter.addNoise': 'Add Noise...',
  'filter.pixelate': 'Mosaic...',
  'filter.emboss': 'Emboss...',
  'filter.findEdges': 'Find Edges',
  'filter.invert': 'Invert',
  'filter.desaturate': 'Desaturate',
  'filter.vignette': 'Vignette...',
  'menu.filter': 'Filter',
  'filter.cat.blur': 'Blur',
  'filter.cat.sharpen': 'Sharpen',
  'filter.cat.noise': 'Noise',
  'filter.cat.pixelate': 'Pixelate',
  'filter.cat.stylize': 'Stylize',
  'filter.cat.other': 'Other',
  'filter.p.radius': 'Radius',
  'filter.p.amount': 'Amount',
  'filter.p.angle': 'Angle',
  'filter.p.distance': 'Distance',
  'filter.p.threshold': 'Threshold',
  'filter.p.monochrome': 'Monochromatic',
  'filter.p.cell': 'Cell Size',
  'filter.p.height': 'Height',
  'filter.p.softness': 'Softness',
  'filter.preview': 'Preview',
  'filter.needRaster': 'Filters apply to raster layers only (rasterize text / shapes first)',
  'history.filter': 'Filter: {name}',
  'menu.help.bridge': 'Connect to Agent (MCP)',
  'menu.help.bridgePort': 'MCP Bridge Port...',
  'bridge.connected': 'MCP connected',
  'bridge.connecting': 'MCP waiting',
  'bridge.disconnected': 'MCP off',
  'bridge.hint': 'Start the local MCP bridge (packages/mcp-server) to connect (port {port})',
  'tool.clone': 'Clone Stamp Tool',
  'tool.dodge': 'Dodge Tool',
  'tool.burn': 'Burn Tool',
  'tool.sponge': 'Sponge Tool',
  'tool.blurTool': 'Blur Tool',
  'tool.sharpenTool': 'Sharpen Tool',
  'options.exposure': 'Exposure',
  'options.strength': 'Strength',
  'options.aligned': 'Aligned',
  'options.desaturate': 'Desaturate',
  'options.saturate': 'Saturate',
  'clone.setSource': 'Alt+click to set the clone source',
  'history.clone': 'Clone Stamp',
  'history.dodge': 'Dodge',
  'history.burn': 'Burn',
  'history.sponge': 'Sponge',
  'history.blurTool': 'Blur',
  'history.sharpenTool': 'Sharpen',
  'panel.histogram': 'Histogram / Info',
  'histogram.lum': 'Luminosity',
  'histogram.mean': 'Mean',
  'histogram.median': 'Median',
  'histogram.selection': 'Sel',
  'menu.view.rulers': 'Rulers',
  'menu.view.guides': 'Show Guides',
  'menu.view.grid': 'Show Grid',
  'menu.view.snap': 'Snap',
  'menu.view.clearGuides': 'Clear Guides',
  'menu.view.gridSize': 'Grid Size...',
  'history.addGuide': 'Add Guide',
  'history.moveGuide': 'Move Guide',
  'history.removeGuide': 'Delete Guide',
  'history.clearGuides': 'Clear Guides',
  'shortcut.rulers': 'Rulers',
  'shortcut.grid': 'Grid',
  'shortcut.guides': 'Guides',
  'shortcut.quickMask': 'Quick Mask mode',
  'menu.select.quickMask': 'Edit in Quick Mask Mode',
  'menu.select.saveChannel': 'Save Selection...',
  'menu.select.loadChannel': 'Load Selection',
  'history.quickMask': 'Quick Mask',
  'history.saveChannel': 'Save Selection',
  'history.loadChannel': 'Load Selection',
  'history.removeChannel': 'Delete Channel',
  'history.renameChannel': 'Rename Channel',
  'panel.channels': 'Channels',
  'channels.empty': 'No saved selections',
  'channels.load': 'Load as selection',
  'channels.delete': 'Delete',
  'export.estimated': 'Estimated size',
  'export.preview': 'Preview',
  'export.original': 'Original',
  'export.stripMeta': 'Metadata is not included (re-encoded)',
  'filter.median': 'Median...',
  'filter.despeckle': 'Despeckle',
  'filter.dustScratches': 'Dust & Scratches...',
  'filter.reduceNoise': 'Reduce Noise...',
  'filter.oilPaint': 'Oil Paint...',
  'filter.p.strength': 'Strength',
  'filter.p.preserveDetails': 'Preserve Details',
  'filter.working': 'Working…',
  'align.left': 'Align Left Edges',
  'align.hcenter': 'Align Horizontal Centers',
  'align.right': 'Align Right Edges',
  'align.top': 'Align Top Edges',
  'align.vcenter': 'Align Vertical Centers',
  'align.bottom': 'Align Bottom Edges',
  'align.distributeH': 'Distribute Horizontally',
  'align.distributeV': 'Distribute Vertically',
  'menu.layer.align': 'Align',
  'menu.layer.distribute': 'Distribute',
  'history.alignLayers': 'Align Layers',
  'history.distributeLayers': 'Distribute Layers',
  'panel.actions': 'Actions',
  'actions.record': 'Start recording',
  'actions.stop': 'Stop recording',
  'actions.play': 'Play',
  'actions.delete': 'Delete',
  'actions.rename': 'Rename',
  'actions.export': 'Export as JSON',
  'actions.import': 'Import JSON',
  'actions.batch': 'Batch apply to files...',
  'actions.empty': 'No actions. Press ● to record menu and dialog operations (commands)',
  'actions.recording': 'Recording: {name} ({n})',
  'actions.newName': 'New Action',
  'actions.played': 'Played action "{name}"',
  'actions.failed': 'Action failed: {error}',
  'actions.imported': 'Imported {n} actions',
  'actions.batchDone': 'Processed {n} files',
  'actions.steps': '{n} steps',
  'tool.pen': 'Pen Tool',
  'pen.hint': 'Click to add anchors, drag for curves. Click the first point to close, Enter to commit, Esc to cancel',
  'pen.commit': 'Commit Path',
  'pen.cancel': 'Cancel',
  'history.editPath': 'Edit Path',
  'shortcuts.change': 'Change',
  'shortcuts.press': 'Press keys… (Esc to abort)',
  'shortcuts.reset': 'Reset to defaults',
  'shortcuts.editHint': 'Click a shortcut to change it. Settings are stored in this browser',
  'filter.liquify': 'Liquify...',
  'liquify.warp': 'Forward Warp',
  'liquify.reconstruct': 'Reconstruct',
  'liquify.twirlCw': 'Twirl Clockwise',
  'liquify.twirlCcw': 'Twirl Counterclockwise',
  'liquify.pucker': 'Pucker',
  'liquify.bloat': 'Bloat',
  'liquify.size': 'Brush Size',
  'liquify.pressure': 'Pressure',
  'liquify.mesh': 'Show Mesh',
  'liquify.restoreAll': 'Restore All',
  'liquify.proxy': 'Editing a {pct}% preview (applied at full resolution on OK)',
  'liquify.frozen': 'Areas outside the selection are frozen',
  'liquify.empty': 'The layer has no pixels',
  'history.liquify': 'Liquify',
  'tool.quickSelect': 'Quick Selection Tool',
  'history.quickSelect': 'Quick Selection',
  'history.colorRange': 'Color Range',
  'history.refineEdge': 'Refine Edge',
  'menu.select.colorRange': 'Color Range...',
  'menu.select.refine': 'Refine Edge...',
  'colorRange.title': 'Color Range',
  'colorRange.fuzziness': 'Fuzziness',
  'colorRange.invert': 'Invert',
  'colorRange.pick': 'Click the preview to pick the sample color',
  'colorRange.sampleAll': 'Sample All Layers',
  'refine.title': 'Refine Edge',
  'refine.smooth': 'Smooth',
  'refine.feather': 'Feather',
  'refine.contrast': 'Contrast',
  'refine.shift': 'Shift Edge',
  'menu.select.subject': 'Select Subject (AI)...',
  'menu.layer.removeBackground': 'Remove Background (AI)...',
  'menu.help.ai': 'AI Model Settings...',
  'history.aiSelect': 'Select Subject (AI)',
  'history.aiRemoveBackground': 'Remove Background (AI)',
  'history.setMask': 'Set Layer Mask',
  'ai.consent.title': 'About downloading AI models',
  'ai.consent.body': 'This app normally never talks to the network. To use the AI features (select subject / remove background) it must download an inference runtime and a model once. The files are stored in this browser; your images and edits are never uploaded.',
  'ai.consent.what': 'What',
  'ai.consent.from': 'From',
  'ai.consent.size': 'Size',
  'ai.consent.license': 'License',
  'ai.consent.model': 'Model',
  'ai.consent.note1': 'Downloads happen after consent, the first time an AI feature is used (progress in the status bar)',
  'ai.consent.note2': 'Inference runs entirely in the browser (WebAssembly). Images are not uploaded',
  'ai.consent.note3': 'Model licenses are those of their publishers. RMBG-1.4 is non-commercial only',
  'ai.consent.agree': 'Agree and enable',
  'ai.consent.revoke': 'Revoke consent and delete cache',
  'ai.revoked': 'AI consent revoked and cache deleted',
  'ai.selected': 'Subject selected',
  'ai.removed': 'Background removed as a layer mask (editable)',
  'ai.failed': 'AI failed: {reason}',
  'ai.progress': 'AI: {label} {pct}%',
  'layer.smart': 'Smart Object',
  'menu.layer.convertToSmart': 'Convert to Smart Object',
  'menu.layer.rasterizeSmart': 'Rasterize Smart Object',
  'history.convertToSmart': 'Convert to Smart Object',
  'history.rasterizeSmart': 'Rasterize Smart Object',
  'history.editSmart': 'Edit Smart Object',
  'history.resetSmart': 'Reset Transform',
  'history.replaceSmart': 'Replace Contents',
  'smart.source': 'Source',
  'smart.interpolation': 'Interpolation',
  'smart.reset': 'Reset Transform',
  'smart.rasterize': 'Rasterize',
  'smart.replace': 'Replace Contents...',
  'smart.hint': 'Free Transform applies non-destructively to the source image',
  'tool.heal': 'Healing Brush Tool',
  'tool.spotHeal': 'Spot Healing Brush Tool',
  'history.heal': 'Healing Brush',
  'history.spotHeal': 'Spot Healing',
  'history.contentAwareFill': 'Content-Aware Fill',
  'menu.edit.contentAwareFill': 'Content-Aware Fill',
  'options.lasso.magnetic': 'Magnetic',
  'menu.help.resetWorkspace': 'Reset Workspace',
  'workspace.resetConfirm': 'Reset tool settings, panel sizes and view settings to defaults and reload?',
  'panel.navigator': 'Navigator',
  'panel.swatches': 'Swatches',
  'swatches.add': 'Add foreground color',
  'swatches.hint': 'Click: foreground, Alt+click: background, right-click: remove',
  'transform.mode.free': 'Free Transform',
  'transform.mode.distort': 'Distort',
  'transform.mode.perspective': 'Perspective',
  'text.warp': 'Warp',
  'text.warp.none': 'None',
  'text.warp.arc': 'Arc',
  'text.warp.arcLower': 'Arc Lower',
  'text.warp.arcUpper': 'Arc Upper',
  'text.warp.bulge': 'Bulge',
  'text.warp.flag': 'Flag',
  'text.warp.wave': 'Wave',
  'text.warp.fisheye': 'Fisheye',
  'text.warp.rise': 'Rise',
  'text.warp.bend': 'Bend',
  'text.warp.h': 'Horizontal',
  'text.warp.v': 'Vertical',
  'menu.edit.defineBrush': 'Define Brush Preset...',
  'brush.defined': 'Brush tip defined (select it in the Brush tool options)',
  'options.tip': 'Brush Tip',
  'options.tip.round': 'Round',
  'options.angle': 'Angle',
  'options.roundness': 'Roundness',
  'options.scatter': 'Scatter',
  'options.sizeJitter': 'Size Jitter',
  'options.preset': 'Preset',
  'options.preset.save': 'Save current settings...',
  'options.preset.delete': 'Delete preset...',
  'menu.edit.fill': 'Fill...',
  'menu.edit.stroke': 'Stroke...',
  'menu.image.rotateArbitrary': 'Rotate Arbitrary...',
  'menu.image.trim': 'Trim (Transparent Pixels)',
  'menu.image.autoTone': 'Auto Tone',
  'menu.image.autoContrast': 'Auto Contrast',
  'menu.image.flatten': 'Flatten Image',
  'menu.layer.viaCopy': 'Layer via Copy',
  'menu.layer.viaCut': 'Layer via Cut',
  'menu.layer.mergeDown': 'Merge Down',
  'menu.layer.mergeVisible': 'Merge Visible',
  'shortcut.mergeDown': 'Merge Down',
  'shortcut.mergeVisible': 'Merge Visible',
  'shortcut.viaCopy': 'Layer via Copy',
  'shortcut.viaCut': 'Layer via Cut',
  'shortcut.fill': 'Fill',
  'shortcut.autoTone': 'Auto Tone',
  'shortcut.autoContrast': 'Auto Contrast',
  'history.merge': 'Merge Layers',
  'history.layerViaCopy': 'Layer via Copy',
  'history.layerViaCut': 'Layer via Cut',
  'history.fill': 'Fill',
  'history.stroke': 'Stroke',
  'history.rotateArbitrary': 'Rotate Canvas',
  'dialog.fill.title': 'Fill',
  'dialog.fill.use': 'Use',
  'dialog.fill.foreground': 'Foreground Color',
  'dialog.fill.background': 'Background Color',
  'dialog.fill.custom': 'Color',
  'dialog.fill.opacity': 'Opacity',
  'dialog.stroke.title': 'Stroke',
  'dialog.stroke.width': 'Width',
  'dialog.stroke.position': 'Location',
  'dialog.stroke.inside': 'Inside',
  'dialog.stroke.center': 'Center',
  'dialog.stroke.outside': 'Outside',
  'dialog.rotate.title': 'Rotate Canvas',
  'dialog.rotate.angle': 'Angle (clockwise)',
  'gradient.color': 'Color',
  'gradient.position': 'Location',
  'gradient.opacity': 'Opacity',
  'gradient.reverse': 'Reverse',
  'gradient.remove': 'Delete stop',
  'options.gradientCustom': 'Custom',
  'history.snapshot': 'Snapshot',
  'history.restoreSnapshot': 'Restore Snapshot',
  'snapshot.take': 'New snapshot',
  'snapshot.delete': 'Delete',
  'snapshot.name': 'Snapshot {n}',
  'menu.file.exportLayers': 'Export Layers to Files (PNG ZIP)...',
  'toast.exportedLayers': 'Exported {n} layers',
  'dialog.style.blendIf': 'Blend If',
  'dialog.style.blendIfChannel': 'Channel',
  'dialog.style.gray': 'Gray',
  'dialog.style.thisLayer': 'This Layer',
  'dialog.style.underlying': 'Underlying Layer',
  'dialog.style.blendIfHint': '[shadow start, shadow end, highlight start, highlight end] (0..255). Values between start and end blend smoothly',
  'adj.selective-color': 'Selective Color',
  'adj.sel.range': 'Colors',
  'adj.sel.reds': 'Reds',
  'adj.sel.yellows': 'Yellows',
  'adj.sel.greens': 'Greens',
  'adj.sel.cyans': 'Cyans',
  'adj.sel.blues': 'Blues',
  'adj.sel.magentas': 'Magentas',
  'adj.sel.whites': 'Whites',
  'adj.sel.neutrals': 'Neutrals',
  'adj.sel.blacks': 'Blacks',
  'adj.relative': 'Relative',
  'pattern.title': 'Pattern',
  'pattern.none': 'No patterns (Edit → Define Pattern)',
  'pattern.defined': 'Pattern defined',
  'menu.edit.definePattern': 'Define Pattern...',
  'menu.layer.newFillPattern': 'New Fill Layer (Pattern)',
  'fx.patternOverlay': 'Pattern Overlay',
  'history.definePattern': 'Define Pattern',
  'history.removePattern': 'Delete Pattern',
  'adj.color-lookup': 'Color Lookup',
  'adj.lut.current': 'LUT',
  'adj.lut.none': '(none: identity)',
  'adj.lut.preset': 'Preset',
  'adj.lut.load': 'Load .cube...',
  'adj.lut.identity': 'Identity',
  'adj.lut.sepia': 'Sepia',
  'adj.lut.warm': 'Warm',
  'adj.lut.cool': 'Cool',
  'adj.lut.crisp': 'Crisp',
  'adj.lut.faded': 'Faded',
  'adj.lut.mono': 'Monochrome',
  'menu.layer.strokePath': 'Stroke Path with Brush',
  'menu.layer.fillPath': 'Fill Path',
  'history.strokePath': 'Stroke Path',
  'history.fillPath': 'Fill Path',
  'transform.mode.warp': 'Warp',
  'history.warp': 'Warp',
  'panel.comps': 'Layer Comps',
  'comps.add': 'New Layer Comp',
  'comps.apply': 'Apply',
  'comps.update': 'Update from current state',
  'comps.delete': 'Delete',
  'comps.empty': 'No layer comps. Press + to save the current visibility / positions / styles',
  'history.addComp': 'Add Layer Comp',
  'history.updateComp': 'Update Layer Comp',
  'history.applyComp': 'Apply Layer Comp',
  'history.removeComp': 'Delete Layer Comp',
  'history.renameComp': 'Rename Layer Comp',
  'tool.smudge': 'Smudge Tool',
  'history.smudge': 'Smudge',
  'guide.open': 'Tool Guide (F1)',
  'guide.steps': 'How to use',
  'guide.keys': 'Keys',
  'guide.tip': 'Tip',
  'guide.close': 'Close',
  'guide.switchHint': 'Switch tools and this updates',
  'guide.allShortcuts': 'All shortcuts',
  'guide.hintSuffix': '(F1 for details)',
  'guide.hintsReset': 'First-use tool hints reset',
  'menu.help.toolGuide': 'Tool Guide',
  'menu.help.resetHints': 'Show first-use tool hints again',
  'shortcut.toolGuide': 'Show / hide the Tool Guide',
  'mobile.title': 'Phones are not supported',
  'mobile.body': 'This app is built for desktop browsers. It cannot be operated properly on a phone, so please open it on a computer.',
  'mobile.r1': 'It assumes precise mouse or pen input and keyboard shortcuts',
  'mobile.r2': 'The toolbar, options bar and panels need horizontal space',
  'mobile.r3': 'Compositing uses a desktop GPU and its memory',
  'mobile.copy': 'Copy link',
  'mobile.copied': 'Copied',
  'mobile.continue': 'Open anyway (not supported)',
  'mobile.repo': 'View on GitHub',
  'start.guide': 'See how the tools work (F1)',
  'tool.crop': 'Crop Tool',
  'tool.eyedropper': 'Eyedropper Tool',
  'tool.brush': 'Brush Tool',
  'tool.eraser': 'Eraser Tool',
  'tool.fill': 'Paint Bucket Tool',
  'tool.gradient': 'Gradient Tool',
  'tool.text': 'Horizontal Type Tool',
  'tool.shape': 'Rectangle Tool',
  'tool.comingSoon': '(coming in a later phase)',
  'panel.layers': 'Layers',
  'panel.properties': 'Properties',
  'panel.history': 'History',
  'layer.opacity': 'Opacity',
  'layer.fill': 'Fill',
  'layer.blendMode': 'Blend Mode',
  'layer.name': 'Name',
  'layer.visible': 'Toggle visibility',
  'layer.background': 'Background',
  'layer.new': 'New Layer',
  'layer.delete': 'Delete',
  'layer.empty': 'No layers',
  'layer.lockedHint': 'Locked',
  'start.title': 'Image editing in your browser',
  'start.subtitle': 'Your images never leave this device. Saving is manual (ZIP / image export).',
  'start.new': 'New Document',
  'start.open': 'Open Image / Project',
  'start.drop': 'Drop an image or .bpe.zip here',
  'dialog.new.title': 'New Document',
  'dialog.new.name': 'Name',
  'dialog.new.width': 'Width',
  'dialog.new.height': 'Height',
  'dialog.new.dpi': 'Resolution (dpi)',
  'dialog.new.background': 'Background',
  'dialog.new.bg.transparent': 'Transparent',
  'dialog.new.bg.white': 'White',
  'dialog.new.bg.black': 'Black',
  'dialog.new.create': 'Create',
  'dialog.new.preset': 'Preset',
  'dialog.export.title': 'Export Image',
  'dialog.export.format': 'Format',
  'dialog.export.quality': 'Quality',
  'dialog.export.scale': 'Scale',
  'dialog.export.size': 'Output size',
  'dialog.export.run': 'Export',
  'dialog.export.transparentHint': 'JPEG flattens transparency to white',
  'dialog.cancel': 'Cancel',
  'dialog.ok': 'OK',
  'dialog.close.confirm': 'You have unsaved changes. Close anyway?',
  'unsaved.badge': 'Unsaved',
  'unsaved.beforeUnload': 'You have unsaved changes.',
  'toast.opened': 'Opened {name}',
  'toast.saved': 'Project saved',
  'toast.savedWithFonts': 'Saved ({n} font(s) embedded)',
  'toast.fontsMissing': 'Fonts not installed here: {fonts} — shown with a substitute',
  'toast.exported': 'Exported {name}',
  'toast.openFailed': 'Could not open: {reason}',
  'toast.saveFailed': 'Could not save: {reason}',
  'toast.unsupportedFile': 'Unsupported file type: {name}',
  'toast.tooLarge': 'Image too large (max {max}px): {w}×{h}',
  'toast.webglLost': 'GPU context lost. Recovering...',
  'toast.webglRestored': 'GPU context restored',
  'toast.undo': 'Undo: {label}',
  'toast.redo': 'Redo: {label}',
  'history.addLayer': 'Add Layer',
  'history.deleteLayer': 'Delete Layer',
  'history.duplicateLayer': 'Duplicate Layer',
  'history.renameLayer': 'Rename Layer',
  'history.layerProps': 'Layer Properties',
  'history.toggleVisible': 'Toggle Visibility',
  'history.moveLayer': 'Move Layer',
  'history.reorderLayer': 'Reorder Layer',
  'history.openImage': 'Open Image',
  'history.placeImage': 'Place Image',
  'history.groupLayers': 'Group Layers',
  'history.ungroupLayers': 'Ungroup Layers',
  'history.clipLayer': 'Clipping Mask',
  'history.addMask': 'Add Layer Mask',
  'history.removeMask': 'Delete Layer Mask',
  'history.toggleMask': 'Toggle Layer Mask',
  'menu.layer.group': 'Group Layers',
  'menu.layer.ungroup': 'Ungroup Layers',
  'menu.layer.clip': 'Create/Release Clipping Mask',
  'menu.layer.addMaskReveal': 'Add Layer Mask (Reveal All)',
  'menu.layer.addMaskHide': 'Add Layer Mask (Hide All)',
  'menu.layer.removeMask': 'Delete Layer Mask',
  'menu.layer.toggleMask': 'Enable/Disable Layer Mask',
  'layer.mask': 'Mask',
  'layer.clipped': 'Clipped to layer below',
  'layer.group': 'Group',
  'shortcut.group': 'Group layers',
  'menu.select': 'Select',
  'menu.select.all': 'All',
  'menu.select.deselect': 'Deselect',
  'menu.select.invert': 'Inverse',
  'menu.select.feather': 'Feather...',
  'menu.select.expand': 'Expand...',
  'menu.select.contract': 'Contract...',
  'menu.select.border': 'Border...',
  'menu.edit.clear': 'Clear',
  'shortcut.selectAll': 'Select all',
  'shortcut.deselect': 'Deselect',
  'shortcut.invert': 'Inverse selection',
  'shortcut.clear': 'Clear selection / delete layer',
  'history.select': 'Selection',
  'history.selectAll': 'Select All',
  'history.deselect': 'Deselect',
  'history.invertSelection': 'Inverse',
  'history.featherSelection': 'Feather',
  'history.expandSelection': 'Expand',
  'history.contractSelection': 'Contract',
  'history.borderSelection': 'Border',
  'history.clearPixels': 'Clear',
  'options.mode.new': 'New',
  'options.mode.add': 'Add',
  'options.mode.subtract': 'Subtract',
  'options.mode.intersect': 'Intersect',
  'options.shape.rect': 'Rectangle',
  'options.shape.ellipse': 'Ellipse',
  'options.lasso.free': 'Freehand',
  'options.lasso.polygon': 'Polygonal',
  'options.feather': 'Feather',
  'options.antialias': 'Anti-alias',
  'options.tolerance': 'Tolerance',
  'options.contiguous': 'Contiguous',
  'options.sampleAll': 'Sample All Layers',
  'dialog.modify.amount': 'Amount (px)',
  'dialog.modify.feather': 'Feather Selection',
  'dialog.modify.expand': 'Expand Selection',
  'dialog.modify.contract': 'Contract Selection',
  'dialog.modify.border': 'Border Selection',
  'shortcut.clip': 'Clipping mask',
  'unsupported.title': 'This browser is not supported',
  'unsupported.body': 'This app composites images with WebGL2, which is not available in your browser or GPU configuration. Please use a current Chrome / Edge / Firefox / Safari, or enable hardware acceleration.',
  'status.zoom': 'Zoom',
  'status.size': 'Size',
  'status.memory': 'Memory',
  'status.noDocument': 'No document',
  'fontEmbed.title': 'Careful about redistributing fonts',
  'fontEmbed.body': 'The saved project contains these font files as-is (not subsetted). The fonts themselves do not permit being embedded.',
  'fontEmbed.restricted': 'Embedding and transfer are not allowed (fsType: restricted)',
  'fontEmbed.previewPrint': 'Preview and print only; embedding in an editable file is out of scope (fsType: preview & print)',
  'fontEmbed.note': 'Opening it yourself is fine. Do not hand this project file to anyone else. Exported images (PNG / JPEG) carry no such restriction.',
  'about.body': 'A Photoshop-like image editor that runs entirely in the browser. Version {version}',
  'about.fonts': 'Bundled fonts (SIL Open Font License 1.1):',
  'shortcut.undo': 'Undo',
  'shortcut.redo': 'Redo',
  'shortcut.zoomIn': 'Zoom in',
  'shortcut.zoomOut': 'Zoom out',
  'shortcut.fit': 'Fit on screen',
  'shortcut.actual': '100%',
  'shortcut.hand': 'Hand (while held)',
  'shortcut.new': 'New document',
  'shortcut.open': 'Open',
  'shortcut.save': 'Save project',
  'shortcut.export': 'Export image',
  'shortcut.newLayer': 'New layer',
  'shortcut.deleteLayer': 'Delete layer',
  'shortcut.tool': 'Switch tool',
  'shortcut.polygonClose': 'Close / cancel polygon selection',
  'shortcut.brushSize': 'Brush size',
  'shortcut.swapColors': 'Swap foreground / background',
  'shortcut.resetColors': 'Default colors',
  'history.brush': 'Brush',
  'history.pencil': 'Pencil',
  'history.eraser': 'Eraser',
  'options.size': 'Size',
  'options.hardness': 'Hardness',
  'options.opacity': 'Opacity',
  'options.flow': 'Flow',
  'options.spacing': 'Spacing',
  'options.smoothing': 'Smoothing',
  'options.pencil': 'Pencil mode',
  'options.pressureSize': 'Pressure → size',
  'options.pressureFlow': 'Pressure → flow',
  'color.foreground': 'Foreground',
  'color.background': 'Background',
  'color.swap': 'Swap (X)',
  'color.reset': 'Default (D)',
  'color.hex': 'HEX',
  'tool.pencil': 'Pencil Tool',
  'brush.needRasterLayer': 'Select a raster layer',
  'options.gradient.linear': 'Linear',
  'options.gradient.radial': 'Radial',
  'options.gradient.angle': 'Angle',
  'options.gradient.reflected': 'Reflected',
  'options.gradient.diamond': 'Diamond',
  'options.reverse': 'Reverse',
  'options.dither': 'Dither',
  'options.toTransparent': 'Foreground → transparent',
  'history.gradient': 'Gradient',
  'brush.locked': 'The layer is locked'
}
